module.exports = __webpack_public_path__ + "static/media/issue6.e028b78c.webp";